module.exports = __webpack_public_path__ + "static/media/menu.83ed2fea.svg";